import React from 'react';
import './PrivacyPolicy.css';

const Disclaimers = () => (
  <div className="legal-page">
    <div className="container">
      <h1>Disclaimers</h1>
      <p className="legal-effective">Effective Date: February 17, 2026</p>
      <p>The information provided on this website by Solace Care 360 ("Company," "we," "our," or "us") is for general informational and business purposes only.</p>
      <p>By accessing this website, you acknowledge and agree to the following:</p>

      <h2>No Medical Advice</h2>
      <p>The content on this website does not constitute medical advice, diagnosis, or treatment.</p>
      <p>Solace Care 360 provides nurse-led care management services in collaboration with licensed healthcare providers and practices. Clinical decisions are made solely by licensed providers responsible for patient care.</p>
      <p>Nothing on this website should be relied upon as a substitute for professional medical advice.</p>
      <p>If you are experiencing a medical emergency, call 911 immediately.</p>

      <h2>No Provider–Patient Relationship</h2>
      <p>Use of this website does not establish:</p>
      <ul>
        <li>A nurse–patient relationship</li>
        <li>A provider–patient relationship</li>
        <li>A clinical care relationship</li>
      </ul>
      <p>A formal relationship is established only through written agreement with Solace Care 360 or through engagement with a participating healthcare practice.</p>

      <h2>Revenue & Reimbursement Disclaimer</h2>
      <p>Descriptions of care management programs, reimbursement strategies, compliance alignment, or revenue optimization are provided for informational purposes only.</p>
      <p>Solace Care 360 does not guarantee:</p>
      <ul>
        <li>Specific reimbursement outcomes</li>
        <li>Payer approvals</li>
        <li>Revenue increases</li>
        <li>Regulatory determinations</li>
      </ul>
      <p>Reimbursement outcomes depend on payer policies, documentation accuracy, regulatory interpretation, and other variables beyond our control.</p>

      <h2>Regulatory & Compliance Disclaimer</h2>
      <p>While Solace Care 360 designs programs to align with applicable federal and state regulations, including CMS guidelines, regulatory interpretations may change.</p>
      <p>Nothing on this website should be interpreted as legal advice.</p>
      <p>Healthcare organizations are responsible for ensuring compliance with applicable laws and regulations.</p>

      <h2>No Warranties</h2>
      <p>All information on this website is provided "as is" without warranties of any kind, either express or implied.</p>
      <p>We do not warrant that the website content is:</p>
      <ul>
        <li>Complete</li>
        <li>Accurate</li>
        <li>Current</li>
        <li>Free from error</li>
      </ul>

      <h2>Third-Party Content</h2>
      <p>This website may reference third-party tools, vendors, or resources. We do not control or endorse third-party content and are not responsible for its accuracy or practices.</p>

      <h2>Limitation of Liability</h2>
      <p>To the fullest extent permitted by law, Solace Care 360 shall not be liable for any direct, indirect, incidental, or consequential damages arising from reliance on website content.</p>

      <h2>Website Use at Your Own Risk</h2>
      <p>Use of this website and reliance on any information contained herein is solely at your own risk.</p>

      <h2>Contact Information</h2>
      <p>For questions regarding this Disclaimer, you may contact us via email at: <a href="mailto:Contact@solacecare360.com">Contact@solacecare360.com</a></p>
    </div>
  </div>
);

export default Disclaimers;
